import React from "react";
import { Icon } from "antd";

const TENDENCIA_ESTILO = {
    up: { color: "#16a34a", icon: "arrow-up" },
    down: { color: "#dc2626", icon: "arrow-down" },
    flat: { color: "#64748b", icon: "arrow-right" },
};

export default function KpiCard(props) {
    const estiloTendencia = TENDENCIA_ESTILO[props.tendenciaDireccion] || TENDENCIA_ESTILO.flat;

    return (
        <div className="kpi-card">
            <div className="kpi-card-header">
                <div className="kpi-card-icon" style={{ backgroundColor: props.iconBackground, color: props.iconColor }}>
                    <Icon type={props.icon} />
                </div>
                <span className="kpi-card-label">{props.label}</span>
            </div>
            <div className="kpi-card-value">{props.value}</div>
            {props.tendenciaTexto && (
                <div className="kpi-card-trend" style={{ color: estiloTendencia.color }}>
                    <Icon type={estiloTendencia.icon} /> {props.tendenciaTexto}
                </div>
            )}
        </div>
    );
}
